import { useEffect, useState } from 'react';
import {
  Spin,
  Layout,
} from 'antd';
import { useLocation } from 'react-router-dom';
import { LoadingOutlined } from '@ant-design/icons';
import TabelaExtratosGravados from '../../components/TabelaExtratosGravados';
import * as S from './styles';
import ComboBox from '../../components/ComboBox/ComboBox';
import api from '../../service/api';
import { User } from '../acess';
import { Header } from 'antd/lib/layout/layout';
const { Content } = Layout;

interface LocationState {
  id: string;
}

const ListaExtratos: React.FC = () => {
  const [isSpinning] = useState<boolean>(false)
  const antIcon = <LoadingOutlined style={{ fontSize: 34, color: "#2ce414" }} spin />
  const location = useLocation<LocationState>();
  const queryParams = new URLSearchParams(location.search);
  const id = queryParams.get('id') || location.state?.id || JSON.parse(localStorage.getItem('cliente') || '{}').id;
  const [currentUser, setCurrentUser] = useState<User>();

  useEffect(() => {
    if (!id) return;

    async function GetCliente() {
      try {
        const response = await api.get(`api/Cliente/${id}`);
        setCurrentUser(response.data);
        localStorage.setItem('cliente', JSON.stringify(response.data));
      } catch (error) {
        console.error("Erro ao carregar cliente:", error);
      }
    }

    GetCliente();
  }, [id]);

  return (
    <Spin indicator={antIcon} spinning={isSpinning}>
      <Header
        style={{
          backgroundColor: "#f0f2f5",
          display: 'flex',
          padding: "0 150px",
          height: "auto",
          maxHeight: "60px",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <S.ContainerImage>
          <img src={"data:image/png;base64," + currentUser?.img} alt="logo" />
        </S.ContainerImage>
        <S.ContainerWord>
          Extratos Bancários
        </S.ContainerWord>

        <S.MenuContainer>
          <ComboBox
            options={[
              { label: 'CONCILIADOR VENDAS', url: `/ConciliacaoVendas?id=${id}`, isExternal: true },
              { label: 'CONCILIADOR BANCÁRIO', url: `/ConciliacaoBancaria?id=${id}`, isExternal: true },
              { label: 'PORTAL ADMINISTRADORAS', url: `https://login.assessoriacartoes.com.br/redirect/${id}`, isExternal: true },
            ]}
          />
        </S.MenuContainer>
      </Header>

      {/* Tela */}
      <Layout className="layout">
        <Content style={{ backgroundColor: "white", padding: '0 50px', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', }}>
          <TabelaExtratosGravados currentUser={currentUser} />
        </Content>
      </Layout>
    </Spin>
  )
}

export default ListaExtratos;